"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var _react = require("@emotion/react");
const getFontSize = digits => {
  switch (digits) {
    case 3:
      return '12px';
    case 4:
      return '10px';
    default:
      return '14px';
  }
};
const styles = exports.styles = {
  default: (theme, amountDigits) => /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:", theme.alert, ";overflow:hidden;color:white;font-size:", getFontSize(amountDigits), ";line-height:23px;width:23px;height:23px;" + (process.env.NODE_ENV === "production" ? "" : ";label:default;"))
};